import {useEffect} from 'react';
import {view} from '@sail/ui';
import {LightCard, DarkThemeButton} from '@stripe-internal/conversations-ui';
import {useAnalytics} from '@stripe-internal/inline-data';
import {FormattedMessage, defineMessages} from 'react-intl';
import {safeWindowOpen} from '@stripe-internal/safe-links';

const messages = defineMessages({
  signInTitle: {
    id: 'mse_inline_data.link_universal_help_sign_in.sign_in_title',
    description: 'Label for the sign-in title.',
    defaultMessage: 'Sign in to your {linkBrandName} account',
  },
  signIn: {
    id: 'mse_inline_data.link_universal_help_sign_in.sign_in',
    description: 'Label for the sign-in button.',
    defaultMessage: 'Sign in',
  },
  description: {
    id: 'mse_inline_data.link_universal_help_sign_in.description',
    description: 'Text for the sign-in card.',
    defaultMessage:
      'Clicking below will open a new browser window. This chat will stay right here, so you can pick up where you left off when you return.',
  },
});

export const LinkSignInCard = ({
  url,
  linkBrandName,
}: {
  url: string;
  linkBrandName?: string;
}) => {
  const analytics = useAnalytics();
  const handleClick = () => {
    analytics.action('clicked_login');
    safeWindowOpen(url);
  };
  useEffect(() => {
    analytics.action('login_prompt_shown');
  }, [analytics]);

  return (
    <view.div
      css={{
        marginLeft: 'xlarge',
        marginRight: 'large',
      }}
    >
      <view.div
        css={{
          marginLeft: 'xsmall',
          marginTop: 'xsmall',
        }}
      >
        <LightCard isOuter>
          <view.div css={{stack: 'y', gap: 'medium'}}>
            <view.div
              css={{
                margin: 0,
                fontWeight: 'bold',
                fontSize: 'body.medium.emphasized',
              }}
              data-testid="uh-sign-in-prompt-title"
            >
              <FormattedMessage
                {...messages.signInTitle}
                values={{linkBrandName}}
              />
            </view.div>
            <view.div
              data-testid="uh-sign-in-prompt-description"
              css={{fontSize: 'label.small'}}
            >
              <FormattedMessage {...messages.description} />
            </view.div>
            <view.div css={{stack: 'y', gap: 'small'}}>
              <DarkThemeButton handleClick={handleClick}>
                <FormattedMessage {...messages.signIn} />
              </DarkThemeButton>
            </view.div>
          </view.div>
        </LightCard>
      </view.div>
    </view.div>
  );
};
